import { render, staticRenderFns } from "./NotAccordingToModal.vue?vue&type=template&id=6b102354&scoped=true&"
import script from "./NotAccordingToModal.vue?vue&type=script&lang=js&"
export * from "./NotAccordingToModal.vue?vue&type=script&lang=js&"
import style0 from "./NotAccordingToModal.vue?vue&type=style&index=0&id=6b102354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b102354",
  null
  
)

export default component.exports